import React from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../reducer/user.selectors';
import { ILocalesImagePath } from './LocalesImage.types';

const LocalesImage: React.FC<ILocalesImagePath> = ({ alt, localesPath, className }: ILocalesImagePath) => {
  const currentLanguage = useSelector(selectLanguage);

  const imgSrc = localesPath[currentLanguage]?.img;

  return <img className={className} src={imgSrc} alt={alt} />;
};

export default LocalesImage;
